import { parseBackendDate } from '../services/common.js';

// PMS syncs run every 5-10 min (Kolla) and every 15 min (Open Dental ledger
// refresh), around the clock. Three missed cycles means the balances and
// procedures Newton shows are out of date. On 2026-11-03 the payments worker
// was down for ~15.5 h and the Schedule tab showed $0 family balances for
// visits with hundreds of dollars of new work.
export const STALE_AFTER_MINUTES = 45;

export function formatRelative(date, now) {
  if (!date) return null;
  const diffMs = now.getTime() - date.getTime();
  if (diffMs < 0) return 'just now'; // clock skew between client + server
  const sec = Math.floor(diffMs / 1000);
  if (sec < 30) return 'just now';
  if (sec < 60) return `${sec}s ago`;
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const day = Math.floor(hr / 24);
  if (day < 7) return `${day}d ago`;
  return date.toLocaleDateString();
}

/**
 * Whether the PMS data behind this practice's ledger is out of date, from a
 * ``/kolla-sync-status`` response. Practices without a synced PMS
 * (``configured: false``) are never stale.
 */
export function isSyncStale(status, now = new Date()) {
  if (!status || status.configured === false) return false;
  const succeeded = parseBackendDate(status.lastSucceededAt);
  if (!succeeded) return true; // configured but has never synced
  return now.getTime() - succeeded.getTime() > STALE_AFTER_MINUTES * 60_000;
}
